import { BetBuilderOddStatus } from '../types/BetBuilderOdd';
import { BetBuilderPreviewSummary } from '../types/BetBuilderPreview';

export const isOddsSelectionSummaryInactive = (summary: BetBuilderPreviewSummary): boolean => {
    return summary.status !== BetBuilderOddStatus.Active;
};
